import React from 'react';
import { BackButtonProps } from '../interFaces/interfaces';
import "../css/others/Table.css";
const BackButton: React.FC<BackButtonProps> = ({ className = 'back-button2', label = 'Back' }) => {
  const handleBackClick = () => { window.history.back(); };
  return (
    <button className={className} onClick={handleBackClick}>{label}</button>
  );
};
export default BackButton;